// extracted by mini-css-extract-plugin
export default {"container":"style_container__+sT0X","title":"style_title__OEYnL"};